var _path, _path2, _path3;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgNlFlag = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#21468b",
  d: "M.249 0h24v24h-24z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.249 0h24v16h-24z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ae1c28",
  d: "M.249 0h24v8h-24z"
})));
export default SvgNlFlag;